import { render, staticRenderFns } from "./PageFooterBand.vue?vue&type=template&id=324f067f&"
import script from "./PageFooterBand.vue?vue&type=script&lang=js&"
export * from "./PageFooterBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports